/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React from "react";
import { array, func, string } from "prop-types";
import { useLocation, matchPath } from "react-router-dom";
import './styles.scss';

const activateOnEnterOrSpace = (fn) => (e) => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    fn(e);
  }
};

const Sidebar = ({ onChange = () => {}, items, title, step }) => {
  const location = useLocation();

  const isPathActive = link => matchPath(link, {
    path: location.pathname,
    exact: true
  })

  return (
    <aside className="sidebar d-flex">
      <div className="sidebar__header d-none d-md-block">{title}</div>
      <div className="sidebar__items">
        {items.map((item, index) => (
            <div
              onClick={() => onChange(item)}
              onKeyDown={activateOnEnterOrSpace(() => onChange(item))}
              key={item.link}
              role="button"
              tabIndex={item.disabled ? -1 : 0}
              className={`sidebar__item ${(isPathActive(item.link) || (step === index)) ? "-active" : ""} ${ item.disabled ? "-disabled" : "" }`}
            >
              <div className="sidebar__item--icon-container">
                <i className={item.icon} />
              </div>
               <span className="d-none d-md-inline"> {item.label} </span>
            </div>
        ))}
      </div>
    </aside>
  );
};

Sidebar.propTypes = {
  items: array.isRequired,
  title: string.isRequired,
  onChange: func
};

export default Sidebar;
